import { GeneralCatalogItem, ServerResponse } from 'data-layer-cr/dist/models';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { AnyAction } from 'redux';

import processRequest from '../../../services/processRequest';
import { AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';

// Slice actions
import {
  updateBanks,
  updateCreditCardBanks,
} from '../slice/creditorCatalogSlice';

// Request identifiers
import { GET_BANKS, GET_CREDIT_CARD_BANKS } from '../requestIdentifiers';

export const requestBanks =
  (): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(GET_BANKS, 'requesting'));
    try {
      const response = await processRequest<GeneralCatalogItem[]>({
        method: 'GET',
        url: 'Catalog/policy/creditors',
      });
      const defaultBankItem = {
        id: 0,
        code: '',
        name: ' Seleccionar acreedor',
      };
      response.unshift(defaultBankItem);
      dispatch(updateBanks(response));
      return dispatch(setRequestStatus(GET_BANKS, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(GET_BANKS, 'failure'));
    }
  };

export const requestCreditCardBanks =
  (): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(GET_CREDIT_CARD_BANKS, 'requesting'));
    try {
      const response = await processRequest<
        ServerResponse<GeneralCatalogItem[]>
      >({
        method: 'GET',
        url: 'banks?filter[limit]=1000&filter[sort]=+name',
      });

      dispatch(updateCreditCardBanks(response.data));
      return dispatch(setRequestStatus(GET_CREDIT_CARD_BANKS, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(GET_CREDIT_CARD_BANKS, 'failure'));
    }
  };
